// Meta Pixel (a "dataset" in Meta Events Manager). Does nothing unless REACT_APP_META_PIXEL_ID is set,
// so local dev and previews stay silent and the ID never lives in the code.
const PIXEL_ID = (process.env.REACT_APP_META_PIXEL_ID || '').trim();
const PURCHASE_SEEN_KEY = 'metaPixelPurchases';

let started = false;

export const initMetaPixel = () => {
  if (started || !PIXEL_ID || typeof window === 'undefined') return;
  started = true;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  // Meta would otherwise auto-fire PageView on every route change, including private pages we exclude.
  window.fbq.disablePushState = true;
  window.fbq.allowDuplicatePageViews = true;
  window.fbq('init', PIXEL_ID);
};

const send = (method, name, params, options) => {
  if (!PIXEL_ID || typeof window === 'undefined' || !window.fbq) return;
  try {
    window.fbq(method, name, params || {}, options);
  } catch (error) {
    // Tracking must never break the site.
  }
};

export const trackPageView = () => send('track', 'PageView');
export const trackViewContent = (params) => send('track', 'ViewContent', params);
export const trackInitiateCheckout = (params) => send('track', 'InitiateCheckout', params);

// Fires at most once per order (the success page can be reloaded or revisited).
export const trackPurchase = ({ orderId, value, contentName }) => {
  if (!PIXEL_ID) return;
  let seen = [];
  try {
    seen = JSON.parse(localStorage.getItem(PURCHASE_SEEN_KEY) || '[]');
  } catch (error) {
    seen = [];
  }
  if (orderId && seen.includes(orderId)) return;
  send(
    'track',
    'Purchase',
    { value: Number(value) || 0, currency: 'INR', content_name: contentName, content_type: 'product' },
    orderId ? { eventID: orderId } : undefined
  );
  if (orderId) {
    try {
      localStorage.setItem(PURCHASE_SEEN_KEY, JSON.stringify([...seen, orderId].slice(-20)));
    } catch (error) {
      // ignore: worst case the event repeats on a reload
    }
  }
};
